import { GraphInputHelpers } from '@/fetching/graphql/GraphInputHelpers';
import { VisitOutcome } from '@/types/visit';

import {
    ContainerDefinitionType,
    defaultVisitsRowToLink,
    makeContainerDefinition,
} from '../definitions';
import { RootEntity, VisitDashboardContainer } from '../types';
import { IDashboardVariationConfig } from './types';

export const ELEANOR_HEALTH_DASHBOARD_CONFIG: IDashboardVariationConfig = {
    containers: [
        {
            key: 'eleanorRnPositionNeeded',
            label: 'MSUD Intake Visit Needs Nursing',
            hoverText: 'Visit requires RN clinician appointment to be added.',
            tableConfig: {
                entity: RootEntity.VISIT,
                filters: {
                    services: {
                        externalIds: {
                            type: { exact: 'APPOINTMENT_TYPE_ID' },
                            value: { exact: '593' },
                        },
                    },
                    outcome: { exact: VisitOutcome.NONE },
                    AND: {
                        NOT: {
                            patient: {
                                visits: {
                                    services: { name: { iContains: 'Nursing Intake' } },
                                },
                            },
                        },
                    },
                },
                rowToLink: defaultVisitsRowToLink,
                emptyTableText: 'No new patient visits need RN positions at this time',
            },
            defaultEnabled: true,
        } satisfies VisitDashboardContainer,
        makeContainerDefinition({
            type: ContainerDefinitionType.UNASSIGNED,
            defaultEnabled: true,
        }),
        {
            key: 'eleanorRnPatientPayerMismatch',
            label: 'Payer Mismatch',
            tableConfig: {
                entity: RootEntity.VISIT,
                filters: {
                    clinicianAppointments: {
                        clinician: { id: { isNull: false } },
                        arePatientClinicianPayersCompatible: { exact: false },
                    },
                    effectiveDate: { gte: GraphInputHelpers.date(new Date()) },
                    outcome: { exact: VisitOutcome.NONE },
                    NOT: {
                        notesForDashboard: { iContains: 'axle-ignore-payer-mismatch' },
                    },
                },
                emptyTableText: 'No payer mismatches at this time.',
                rowToLink: defaultVisitsRowToLink,
            },
            hoverText: 'Visits with clinician and patient payer mismatches.',
            defaultEnabled: true,
        } satisfies VisitDashboardContainer,
        makeContainerDefinition({
            type: ContainerDefinitionType.VISIT_CLINICIAN_APPOINTMENT_SYNC_ISSUES,
            defaultEnabled: true,
        }),
        makeContainerDefinition({
            type: ContainerDefinitionType.UNSYNCED_PATIENTS,
            defaultEnabled: true,
        }),
    ],
};
